// extracted by mini-css-extract-plugin
export default {"container":"FAQ_container__l5GOv","accordions":"FAQ_accordions__1zfuW"};